<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="数据源" name="1">
        <div class="data-source-type">
          <cx-slider :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
          <div v-show="noCacheComponent">
            <!-- <div class="dataSource-item mt12" @click="goToChooseData">
              <span>进入数据管理后台 </span>
            </div> -->
            <data-center-choose 
              :checkStatus="checkStatus"
              :myId="ids"
              :options="options"
              class="mt12"
              @onDataCenterChange="onDataCenterChange"
              @onAfterDataCenterChoose="onAfterDataCenterChoose"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-if="!noCacheComponent" title="数据内容" name="2">
        <div class="content">
          <div class="content-item verticallyCenter mb16">
            <div class="dataTableContainer">
              <div class="outline">
                <div class="scrollTop">
                  <ul ref="scrollTop">
                    <li v-for="(item, index) in tableHeadX" :key="index">
                      <span>{{ item }}</span>
                    </li>
                  </ul>
                </div>
                <div class="scrollLeft">
                  <ul ref="scrollLeft">
                    <li v-for="(item, index) in tableHeadY" :key="index">
                      <span>{{ item }}</span>
                    </li>
                  </ul>
                </div>
                <div class="scrollTable" @scroll="scrollTableHandle" ref="scrollTable">
                  <table>
                    <tbody>
                      <tr v-for="(trItem, trIndex) in danmuDatas" :key="'tr-' + trIndex">
                        <td class="cell">
                          <input type="text" :value="trItem.name" @blur="changeData('name', trIndex, $event)" />
                        </td>
                        <td class="cell">
                          <input type="text" :value="trItem.link" @blur="changeData('link', trIndex, $event)" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="noCacheComponent" title="更多" name="3">
        <div class="data-source-type">
          <auto-update-timer/>
          <!-- <div class="getDataBtn" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
          <cx-check-box v-if="request_prefix === 'bigScreen'" :value.sync="usePageQuery" class="mt16">
            开启跨页面传参
          </cx-check-box>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { _throttle } from "utils"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "danmu-options-data",
  components: { autoUpdateTimer, dataCenterChoose },
  props: { options: Object },
  data() {
    return {
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2"],
      tableHeadX: ["名称", "外链地址"],
      tableHeadY: [],
      fetchEnd: false,
      dataOptions: [{ value: false, title: "本地数据" }, { value: true, title: "数据中心" }]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    content: {
      get() {
        return this.options.content
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
      }
    },
    danmuDatas: {
      get() {
        return this.options && this.options.danmuDatas ? this.options.danmuDatas : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "danmuDatas", false, null)
      }
    },
    isEmptyData: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isEmptyData", "isEmptyData", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isEmptyData", false, null)
      }
    },
    checkStatus() {
      return this.options.appId
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.listenStorage)
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
    init() {
      for (let i = 1; i < 51; i++) {
        this.tableHeadY.push(String(i))
        if (i > this.danmuDatas.length) {
          this.danmuDatas.push({ name: "", link: "" })
        }
      }
    },
    changeData(hrefName, index, e) {
      let val = e.target.value
      if (val !== this.danmuDatas[index][hrefName]) {
        this.$set(this.danmuDatas[index], hrefName, val)
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!moduleId || !appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => {
            this.fetchEnd = false
          })
      }
      this.fetchEnd = false
      if (appId) {
        window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
      }
      // 数据自动渲染
      window.addEventListener("storage", this.listenStorage)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(
          this,
          datas => {
            let tmpData = []
            datas.forEach(item => {
              tmpData.push({
                name: item[Object.keys(item)[0]].value
              })
            })
            this.danmuDatas = tmpData
            if (tmpData.length === 0) {
              this.isEmptyData = true
            } else {
              this.isEmptyData = false
            }
          },
          50
        )
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    // 表格序号和表格内容一起滚动
    scrollTableHandle: _throttle(function (event) {
      let scrollTop = event.target.scrollTop
      let scrollLeft = event.target.scrollLeft
      this.$refs.scrollLeft.style.top = -scrollTop + "px"
      this.$refs.scrollTop.style.left = -scrollLeft + "px"
    }, 10),
    listenStorage(e) {
      if (e.key == "page-v2-data-update") {
        // 后台配置或数据更新
        console.log("后台配置或数据更新 :>>")
        this.getBaseModuleDataLoop()
      }
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    onAfterDataCenterChoose() {
      window.addEventListener("storage", this.listenStorage)
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
  &:hover {
    cursor: pointer;
  }
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item {
  input {
    width: 252px;
    height: 32px;
    background: #35383f;
    color: rgba(255, 255, 255, 0.2);
  }
  .tips {
    color: var(--fourthTextColor);
  }
}
.dataTableContainer {
  width: 228px;
  height: 270px;
  overflow: hidden;
  background-color: var(--dataTableBgColor);
  position: relative;
  .outline {
    font-size: 12px;
    position: relative;
    z-index: 0;
    margin-top: 10px;
  }
  .scrollTop {
    height: 18px;
    width: 204px;
    user-select: none;
    overflow: hidden;
    position: absolute;
    left: 24px;
    ul {
      height: inherit;
      position: relative;
      text-align: center;
      cursor: pointer;
    }
    li {
      display: block;
      box-sizing: border-box;
      height: 18px;
      width: 102px;
      border: 1px solid var(--borderColorNine);
      border-bottom: none;
      float: left;
      position: relative;
      &:first-of-type {
        border-right: none;
      }
    }
  }
  .scrollTable {
    width: 204px;
    height: 232px;
    overflow-y: auto;
    position: absolute;
    left: 24px;
    top: 18px;
    z-index: 11;
    &::-webkit-scrollbar {
      display: none;
    }
    table {
      border-collapse: collapse;
      width: 100%;
    }
    .cell {
      border: 1px solid var(--borderColorNine);
      width: 84px;
      height: 26px;
      padding: 0 6px;
      box-sizing: border-box;
      &.select {
        background: #102546;
      }
      &.cell.editing {
        border: 1px double #2643a1;
      }
      .value-viewer {
        display: block;
        box-sizing: border-box;
        height: 26px;
        line-height: 26px;
        width: inherit;
        text-align: left;
        padding: 0 2px;
        overflow: hidden;
        white-space: nowrap;
      }
      .data-editor {
        display: block;
        box-sizing: border-box;
        height: 24px;
        line-height: 24px;
        width: 84px;
        text-align: left;
        padding: 0 2px;
        overflow: hidden;
        white-space: nowrap;
        background: none;
        outline: none !important;
        border: 0;
        color: #ffffff;
      }
    }
  }
  .selectArea {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 22;
    pointer-events: none;
  }
  input {
    background-color: transparent;
    color: var(--textColor);
    width: 100%;
  }
  .scrollLeft {
    width: 24px;
    height: 232px;
    background-color: inherit;
    overflow: hidden;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    float: left;
    position: absolute;
    z-index: 33;
    top: 18px;
    ul {
      top: 0;
      position: relative;
      width: 100%;
      background-color: var(--dataTableBgColor);
      text-align: center;
      letter-spacing: -1px;
      margin: 0;
      cursor: pointer;
    }
    li {
      height: 27px;
      line-height: 27px;
      border: 1px solid var(--borderColorNine);
      position: relative;
      margin: 0 -1px -1px 0;
    }
  }
}
</style>
